import DETAILS from "../../constants/about";
import { SECTIONIDS } from "../../constants/sectionId";
import MenuItem from "./MenuItem";

const MENUITEMS = [
  {
    label: ".home",
    href: SECTIONIDS.HERO,
  },
  {
    label: ".works",
    href: SECTIONIDS.WORK,
  },
  {
    label: ".services",
    href: SECTIONIDS.SERVICES,
  },
  {
    label: ".about",
    href: SECTIONIDS.ABOUT,
  },
];

type Props = {
  isActive: boolean;
  transfromOrigin: string;
  onClickMenuItem: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

const Menu = (props: Props) => {
    
  return (
    <>
      <div
        aria-hidden="true"
        className={`h-full w-full bg-black fixed left-0 top-0 transition-all duration-200 pointer-events-none ${
          props.isActive ? "opacity-95" : "opacity-0"
        }`}
      ></div>
      <nav
        style={{
          transformOrigin: props.transfromOrigin,
        }}
        className={`fixed right-0 top-0 transition-all duration-300 h-full w-full 
           ${props.isActive ? `opacity-100 scale-100` : "scale-0 "}`}
      >
        <div className="space-y-4 p-12 pl-4 md:pl-20">
          {MENUITEMS.map((item) => (
            <MenuItem label={item.label} href={item.href} onClick={props.onClickMenuItem}/>
          ))}
        </div>
        <div className="absolute bottom-16 left-12 flex gap-4 md:flex-col">
         
          <a href={DETAILS.lineedIn} target="_blank" rel="noreferrer" style={{ opacity: "1", transform: "none" }}>
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              role="img"
              viewBox="0 0 24 24"
              className="text-xl text-white transition-colors hover:text-violet-300"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title></title>
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
            </svg>  
          </a>
          <a href={DETAILS.instagram} target="_blank" rel="noreferrer" style={{ opacity: "1", transform: "none" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-instagram text-xl text-white transition-colors hover:text-violet-300" viewBox="0 0 16 16">
  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
</svg>
          </a>
        </div>
        <a
          className="absolute bottom-4 right-4 flex items-center gap-2 rounded-full bg-violet-700 px-3 py-3 text-4xl uppercase text-violet-200 transition-colors hover:bg-white hover:text-violet-600 md:bottom-16 md:right-16 md:px-6 md:text-2xl"
          style={{ opacity: "1", transform: "none" }}
          href={`#${SECTIONIDS.CONTACT}`}
          
          rel="noreferrer"
          onClick={props.onClickMenuItem}
        >
          <span className="hidden md:block">contact us</span>{" "}
          <svg
            stroke="currentColor"
            fill="none"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke-linecap="round"
            stroke-linejoin="round"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </a>
      </nav>
    </>
  );
};

export default Menu;
